var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarCog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-cog",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11h16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 15.5v1.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 21v1.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.032 17.25l-1.299 .75"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.27 20l-1.3 .75"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.97 17.25l1.3 .75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.733 20l1.3 .75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCog);
export default __webpack_public_path__ + "static/media/calendar-cog.dce4d45b.svg";
export { ForwardRef as ReactComponent };